var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-link"},[_c('Button',{class:_vm.isActive && 'active',attrs:{"text":"","to":_vm.href,"href":`#${_vm.id}`},on:{"click":function($event){$event.preventDefault();return _vm.scrollTo.apply(null, arguments)}}},[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }